<template>
  <main>
    <div class="add-service">
      <div class="row">
        <div class="col-md-12">
          <TopTemplate>
            <template #left-element>
              <h3>{{ examPlan }}</h3>
            </template>

            <template #right-element>
              <router-link :to="{name: 'examSchedule'}" class="btn btn-outline-primary button" :disabled="loading">
                <i class="arrow left" />
                {{ $t("button.retour") }}
              </router-link>
            </template>
          </TopTemplate>
          <div v-if="is_created" class="alert alert-success" role="alert">
            <span v-if="isEdit"> {{ $t("common.succesExamUpdated") }}</span> <span v-else>{{ $t("common.succesExamDate") }}</span>
          </div>
          <div v-if="isExistDate" class="alert alert-danger" role="alert">
            <span> {{ $t("common.ExamDateExist") }}</span>
          </div>
          <div v-if="loading" class="card mt-2 text-center d-block pt-2 pb-24">
            <div class="spinner-border text-info" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>
          <div v-else class="ajout-container message-add">
            <form novalidate @submit.prevent="onSubmitCreate">
              <div class="row">
                <template v-for="(field, index) in formFields">
                  <div v-if="field.show" ref="simpleselect" class="col-md-6 p-3">
                    <div class="ajout-container__simple">
                      <label>{{ field.label }}<sup>*</sup></label>
                      <v-select
                        v-model="exam[field.model]"
                        :class="{
                          'is-invalid': v$.exam[field.model].$error,
                        }"
                        :multiple="field.multiple"
                        :options="field.options"
                        :label="field.model == 'field_id' ? 'name_fr' : 'name'"
                        :reduce="(option) => option.id"
                        @update:modelValue="SetChange($event, field.model)"
                      >
                        <template #no-options="{}">
                          {{ field.noOptionsText }}
                        </template>
                      </v-select>
                      <span v-if="v$.exam[field.model].$error" class="invalid-feedback">
                        {{ v$.exam[field.model].$errors[0].$message }}
                      </span>
                    </div>
                  </div>
                </template>

                <div class="col-md-6 p-3">
                  <div class="ajout-container__simple">
                    <label>{{ $t("service.dateExamen") }}<sup>*</sup></label>
                    <div class="input-date">
                      <Datepicker
                        v-model="exam.exam_date"
                        :locale="'fr'"
                        :min-date="new Date()"
                        :format="format_date_v1"
                        auto-apply
                        :class="datePickerClass"
                        class="form-control"
                      />
                      <span v-if="v$.exam.exam_date.$error" class="invalid-feedback">
                        {{ v$.exam.exam_date.$errors[0].$message }}
                      </span>
                    </div>
                  </div>
                </div>
                <div class="col-md-6 p-3">
                  <div class="ajout-container__simple">
                    <label>{{ $t("common.hour") }}<sup>*</sup></label>
                    <div class="input-date">
                      <Datepicker
                        v-model="exam.time"
                        :locale="'fr'"
                        disable-time-range-validation
                        time-picker
                        range
                        placeholder="Sélectionnez l'heure"
                        :select-text="'Sélectionner'"
                        :cancel-text="'Annuler'"
                        :class="{
                          'is-invalid': v$.exam.time.$error,
                          'custom-font-size': true,
                        }"
                        @internal-model-change="handleInternal"
                        @focus="getDefaultTimeRange(), handleInternal"
                      >
                        <template #input-icon />
                      </Datepicker>

                      <span v-if="v$.exam.time.$error" class="invalid-feedback">
                        {{ v$.exam.time.$errors[0].$message }}
                      </span>
                    </div>
                  </div>
                </div>
                <div class="col-12 p-3">
                  <div class="ajout-container__multiple">
                    <div class="ajout-container__simple">
                      <label>{{ $t("service.commentaire") }}</label>
                    </div>
                    <textarea v-model="exam.description" class="form-control p-2" maxlength="300" />
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div class="col-12 buttons btn-action btn-planifier-note">
        <div class="button-right d-flex justify-content-end mb-4">
          <button type="submit" class="btn btn-outline-primary button btn-cancel" :disabled="loading" @click.prevent="cancelBtn()">
            {{ $t("button.annuler") }}
          </button>
          <button type="submit" class="btn button btn-primary btn-save" :disabled="loading" @click="onSubmitCreate()">
            {{ $t("button.save") }}
          </button>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import ExamScheduleService from "../../services/examSchedule.Service";
import TopTemplate from "../../components/toptemplate/TopTemplate.vue";
import useValidate from "@vuelidate/core";
import {required, requiredIf, helpers} from "@vuelidate/validators";
import Datepicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import moment from "moment";
import vSelect from "vue-select";

export default {
  components: {
    TopTemplate,
    "v-select": vSelect,
    Datepicker,
  },
  data() {
    return {
      v$: useValidate(),
      id: null,
      isEdit: false,
      isExistDate: false,
      is_created: false,
      loading: false,
      classes: [],
      exam_type: [],
      courses: [],
      time: [],
      fields: [],
      formFields: [],
      exam: {
        class_id: null,
        course_id: null,
        exam_date: null,
        start_time: null,
        end_time: null,
        time: null,
        description: null,
        exam_type_id: null,
        field_id: null,
      },
      params: {
        class_type_id: [],
        field_id: null,
        school_category_id: null,
      },
      schoolCategory: JSON.parse(localStorage.getItem("school_category")),
    };
  },
  validations() {
    return {
      exam: {
        class_id: {
          required: helpers.withMessage(this.$t("validation.required"), required),
        },
        course_id: {
          required: helpers.withMessage(this.$t("validation.required"), required),
        },
        exam_type_id: {
          required: helpers.withMessage(this.$t("validation.required"), required),
        },
        exam_date: {
          required: helpers.withMessage(this.$t("validation.required"), required),
        },
        field_id: {
          requiredIf: requiredIf((value, vm) => {
            return this.formFields[1].show;
          }),
        },
        time: {
          required: helpers.withMessage(this.$t("validation.required"), required),
        },
      },
    };
  },
  computed: {
    datePickerClass() {
      return {"is-invalid": this.v$.exam.exam_date.$error};
    },
    examType() {
      return this.schoolCategory ? this.$t("common.type") : this.$t("barFiltre.examTypeText");
    },
    examPlan() {
      return this.schoolCategory ? this.$t("common.evaluation") : this.$t("title.examDateText");
    },
  },
  created() {
    if (this.$route.params.id !== null && this.$route.params.id !== undefined) {
      this.id = this.$route.params.id;
      this.isEdit = true;
    }
    this.formFields = [
      {label: this.$t("register.classe"), model: "class_id", options: this.classes, noOptionsText: "Aucun résultat", multiple: !this.isEdit, show: true},
      {label: this.$t("common.category"), model: "field_id", options: this.fields, noOptionsText: "Aucun résultat", multiple: false, show: false},
      {label: this.$t("barFiltre.newCourses"), model: "course_id", options: this.courses, noOptionsText: "Aucun résultat", multiple: false, show: true},
      {label: this.examType, model: "exam_type_id", options: this.exam_type, noOptionsText: "Aucun résultat", multiple: false, show: true},
    ];
  },
  async mounted() {
    await this.loadPage();
  },
  methods: {
    async loadPage() {
      this.loading = true;
      try {
        if (this.isEdit) {
          await this.getById(this.id);
        }
        await this.fetchData(true);
      } catch (err) {
        console.error("error : ", err);
      } finally {
        this.loading = false;
      }
    },
    getDefaultTimeRange() {
      if (!this.isCalendarOpen) {
        this.isCalendarOpen = true;
        if (!this.exam.time) {
          const now = new Date();
          const startTime = new Date(now);
          startTime.setMinutes(0);
          const endTime = new Date(now);
          endTime.setMinutes(0);
          endTime.setHours(now.getHours() + 1);
          const parsedTime = moment(startTime, "HH:mm:ss");
          const parsedTimeEnd = moment(endTime, "HH:mm:ss");
          this.exam.time = [
            {
              hours: parsedTime.hours(),
              minutes: parsedTime.minutes(),
              seconds: parsedTime.seconds(),
            },
            {
              hours: parsedTimeEnd.hours(),
              minutes: parsedTimeEnd.minutes(),
              seconds: parsedTimeEnd.seconds(),
            },
          ];
        }
      }
    },
    cancelBtn() {
      return this.$router.push({name: "examSchedule"});
    },
    async getById(id) {
      try {
        const response = await ExamScheduleService.get(id);
        this.exam = response.data;

        this.exam.class_id = this.exam.classe.id;
        this.exam.course_id = this.exam.course.id;
        this.exam.exam_type_id = this.exam.exam_type.id;
        this.params.class_type_id = [this.exam.classe.class_type_id];
        const showField = [1, 4].includes(this.exam.classe.school_category_id);
        this.formFields[1].show = showField;
        if (showField) {
          this.exam.field_id = this.exam.field?.id;
          this.params.field_id = this.exam.field_id;
        }
        const parsedTime = moment(this.exam.start_time, "HH:mm:ss");
        const parsedTimeEnd = moment(this.exam.end_time, "HH:mm:ss");
        this.exam.time = [
          {
            hours: parsedTime.hours(),
            minutes: parsedTime.minutes(),
            seconds: parsedTime.seconds(),
          },
          {
            hours: parsedTimeEnd.hours(),
            minutes: parsedTimeEnd.minutes(),
            seconds: parsedTimeEnd.seconds(),
          },
        ];
      } catch (error) {
        console.error(error);
      }
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    },
    handleInternal(date) {
      if (date && !_.isEqual(date, this.exam.time)) {
        this.exam.start_time = moment(date[0]).locale("fr").format("HH:mm:ss");
        this.exam.end_time = moment(date[1]).locale("fr").format("HH:mm:ss");
      }
    },
    async SetChange(event, field) {
      const {formFields, isEdit} = this;

      const FIELD_CLASS_ID = "class_id";
      const FIELD_FIELD_ID = "field_id";

      if (field === FIELD_CLASS_ID) {
        const [selectedClass] = formFields[0].options.filter((option) => (!isEdit ? event[0] == option.id : event == option.id));
        const classTypes = formFields[0].options.filter((option) => (!isEdit ? event.includes(option.id) : event == option.id));

        this.params.school_category_id = selectedClass?.class_type_category;
        this.params.class_type_id = classTypes.map(({class_type_id}) => class_type_id);
        this.exam.field_id = null;
        this.exam.course_id = null;
        this.exam.exam_type_id = null;
        formFields[1].show = [1, 4].includes(selectedClass?.class_type_category);
        if (!formFields[1].show) {
          const selectedClasses = formFields[0].options.filter((option) => event.includes(option.id));
          this.courses = selectedClasses.length === 1 ? selectedClasses[0].courses : this.getCommonCourses(selectedClasses);

          if (this.courses.length === 0 || (this.exam.course_id !== null && !this.courses.some(({id}) => id === this.exam.course_id))) {
            this.exam.course_id = null;
          }
        }
        this.formFields[2].options = this.courses;
      } else if (field === FIELD_FIELD_ID) {
        this.params.field_id = event;
        this.exam.course_id = null;
        this.exam.exam_type_id = null;
      }
      await this.fetchData(false);
    },
    getCommonCourses(selectedClasses) {
      if (selectedClasses.length === 0) {
        return [];
      }
      const courseCountMap = new Map();
      for (const selectedClass of selectedClasses) {
        for (const course of selectedClass.courses) {
          const courseId = course.id;
          courseCountMap.set(courseId, (courseCountMap.get(courseId) || 0) + 1);
        }
      }
      const commonCourses = Array.from(courseCountMap.entries())
        .filter(([courseId, count]) => count === selectedClasses.length)
        .map(([courseId]) => selectedClasses[0].courses.find((course) => course.id === courseId));

      return commonCourses;
    },
    formatByDate: _.debounce(function () {
      if (this.exam.exam_date != null) {
        this.exam.exam_date = this.dateTime(this.exam.exam_date);
      }
    }, 200),
    dateTime(value) {
      return moment(value).locale("fr").format("YYYY-MM-DD");
    },
    format_date_v1(value) {
      if (value) {
        return moment(String(value)).format("DD-MM-YYYY");
      }
    },
    async fetchData(load_page) {
      try {
        const {school_category_id, class_type_id, field_id} = this.params;
        const config = {
          params: {
            school_category_id: school_category_id || null,
            class_type_id: class_type_id && class_type_id.length ? class_type_id : null,
            field_id: field_id || null,
          },
        };
        const showField = this.formFields[1].show;

        const response = await ExamScheduleService.getFilter(config);
        const {data} = response;

        this.classes = data.classes || [];
        this.formFields[0].options = this.classes;

        this.exam_type = data.exam_types || [];
        this.formFields[3].options = this.exam_type;

        this.fields = data.fields || [];
        this.formFields[1].options = this.fields;

        if (showField) {
          this.courses = data.courses || [];
        }
        if (load_page && !showField) {
          const selectedClass = this.classes.find(({id}) => id === this.exam.class_id);
          this.courses = selectedClass ? selectedClass.courses : [];
        }
        this.formFields[2].options = this.courses;
      } catch (error) {
        console.error(error);
      }
    },
    resetForm() {
      this.v$.$reset();
      this.exam = {
        class_id: null,
        course_id: null,
        exam_date: null,
        start_time: null,
        end_time: null,
        time: null,
        description: null,
        exam_type_id: null,
        field_id: null,
      };
    },

    async onSubmitCreate() {
      try {
        this.isExistDate = false;
        this.is_created = false;
        this.loading = true;
        this.v$.$validate();
        if (!this.v$.$error) {
          // Update 'exam_date' in place
          this.exam.exam_date = moment(String(this.exam.exam_date)).format("YYYY-MM-DD");

          // Omit the 'time' property
          let newObject = {...this.exam, time: undefined};
          let res;
          if (this.isEdit) {
            res = await ExamScheduleService.update(this.id, newObject);
          } else {
            res = await ExamScheduleService.create(newObject);
          }
          if (!this.isEdit) {
            if (res.status === 200) {
              this.resetForm();
            }
          }
          this.scrollToTop();

          this.isExistDate = res.status === 422;

          this.is_created = true;
        }
      } catch (error) {
        if (error.response) {
          this.isExistDate = error.response.status === 422;
          this.scrollToTop();
          console.error("Response data:", error.response.data);
          console.error("Response status:", error.response.status);
          console.error("Response headers:", error.response.headers);
        }
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
